<template>
  <div id="defaultFooter">
    <div class="defaultFooter">
      <div class="defaultFooter-logoBox clearBox">
        <img class="logoBox-li1" src="~@/assets/images/home/img_027.png"/>
        <img class="logoBox-li2" src="~@/assets/images/home/img_026.png"/>
      </div>
      <div class="defaultFooter-content clearBox">
        <template v-if="languageType==1">
          <div class="content-lp clearBox">
            <div class="content-lp-li">
              <div class="li-label">公司电话：</div>
              <div class="li-value">86-755-82543034</div>
            </div>
            <div class="content-lp-li">
              <div class="li-label">微信：</div>
              <div class="li-value">gloriaele</div>
            </div>
            <div class="content-lp-li">
              <div class="li-label">kakao talk:</div>
              <div class="li-value">yb.gloria</div>
            </div>
            <div class="content-lp-li">
              <div class="li-label">工作时间：</div>
              <div class="li-value">{{"周一至周六 9:00–18:00（北京时间）\n支持中文、英语、韩语"}}</div>
            </div>
            <div class="content-lp-li">
              <div class="li-label">联系电话：</div>
              <div class="li-value">86-134 2098 5602</div>
            </div>
            <div class="content-lp-li">
              <div class="li-label">邮箱：</div>
              <div class="li-value">Feynman@gloria-ele.com</div>
            </div>
            <div class="content-lp-li">
              <div class="li-label">Skype/ Teams: </div>
              <div class="li-value">{{"Gloria Electronics\n(live:.cid.bdcb9a03130d7d13)"}}</div>
            </div>
          </div>
        </template>
        <template v-else-if="languageType==2">
          <div class="content-lp clearBox">
            <div class="content-lp-li">
              <div class="li-label">Telephone：</div>
              <div class="li-value">86-755-82543034</div>
            </div>
            <div class="content-lp-li">
              <div class="li-label">Wechat：</div>
              <div class="li-value">gloriaele</div>
            </div>
            <div class="content-lp-li">
              <div class="li-label">kakao talk:</div>
              <div class="li-value">yb.gloria</div>
            </div>
            <div class="content-lp-li">
              <div class="li-label">Business Hours：</div>
              <div class="li-value">{{"Monday to Saturday, 9:00 AM – 6:00 PM (Beijing Time) \n Languages Supported \n Chinese, English, Korean "}}</div>
            </div>
            <div class="content-lp-li">
              <div class="li-label">Mobile：</div>
              <div class="li-value">86-138 2879 8475</div>
            </div>
            <div class="content-lp-li">
              <div class="li-label">E-Mail：</div>
              <div class="li-value">yubin@gloria-ele.com</div>
            </div>
            <div class="content-lp-li">
              <div class="li-label">Skype/ Teams: </div>
              <div class="li-value">{{"Gloria Electronics\n(live:.cid.bdcb9a03130d7d13)"}}</div>
            </div>
          </div>
        </template>
        <template v-else-if="languageType==3">
          <div class="content-lp clearBox">
            <div class="content-lp-li">
              <div class="li-label">Telephone：</div>
              <div class="li-value">86-755-82543034</div>
            </div>
            <div class="content-lp-li">
              <div class="li-label">Wechat：</div>
              <div class="li-value">gloriaele</div>
            </div>
            <div class="content-lp-li">
              <div class="li-label">kakao talk:</div>
              <div class="li-value">yb.gloria</div>
            </div>
            <div class="content-lp-li">
              <div class="li-label">Business Hours：</div>
              <div class="li-value">{{"Monday to Saturday, 9:00 AM – 6:00 PM (Beijing Time) \n Languages Supported \n Chinese, English, Korean "}}</div>
            </div>
            <div class="content-lp-li">
              <div class="li-label">Mobile：</div>
              <div class="li-value">86-138 2879 8475</div>
            </div>
            <div class="content-lp-li">
              <div class="li-label">E-Mail：</div>
              <div class="li-value">yubin@gloria-ele.com</div>
            </div>
            <div class="content-lp-li">
              <div class="li-label">Skype/ Teams: </div>
              <div class="li-value">{{"Gloria Electronics\n(live:.cid.bdcb9a03130d7d13)"}}</div>
            </div>
          </div>
        </template>
        <div class="content-rp">
          <img class="content-rp-codeImg" src="~@/assets/images/contactUs/img_001.png"/>
        </div>
      </div>

      <div class="defaultFooter-djBox">粤ICP备14010311号</div>
    </div>

    <div class="defaultScreenFooter">
      <div class="defaultScreenFooter-logoBox clearBox">
        <img class="logoBox-li1" src="~@/assets/images/home/img_027.png"/>
        <img class="logoBox-li2" src="~@/assets/images/home/img_026.png"/>
      </div>
      <template v-if="languageType==1">
        <div class="defaultScreenFooter-optionBox">
          <div class="optionBox-li">
            <div class="li-label">公司电话：</div>
            <div class="li-value">86-755-82543034</div>
          </div>
          <div class="optionBox-li">
            <div class="li-label">联系电话：</div>
            <div class="li-value">86-134 2098 5602</div>
          </div>
          <div class="optionBox-li">
            <div class="li-label">邮箱：</div>
            <div class="li-value">Feynman@gloria-ele.com</div>
          </div>
          <div class="optionBox-li">
            <div class="li-label">微信：</div>
            <div class="li-value">gloriaele</div>
            <img class="li-codeImg" src="~@/assets/images/contactUs/img_001.png"/>
          </div>
          <div class="optionBox-li">
            <div class="li-label">kakao talk:</div>
            <div class="li-value">yb.gloria</div>
          </div>
          <div class="optionBox-li">
            <div class="li-label">Skype/ Teams: </div>
            <div class="li-value">{{"Gloria Electronics\n(live:.cid.bdcb9a03130d7d13)"}}</div>
          </div>
          <div class="optionBox-li">
            <div class="li-label">工作时间：</div>
            <div class="li-value">{{"周一至周六 9:00–18:00（北京时间）\n支持中文、英语、韩语"}}</div>
          </div>
        </div>
      </template>
      <template v-else-if="languageType==2">
        <div class="defaultScreenFooter-optionBox">
          <div class="optionBox-li">
            <div class="li-label">Telephone：</div>
            <div class="li-value">86-755-82543034</div>
          </div>
          <div class="optionBox-li">
            <div class="li-label">Mobile：</div>
            <div class="li-value">86-138 2879 8475</div>
          </div>
          <div class="optionBox-li">
            <div class="li-label">E-Mail：</div>
            <div class="li-value">yubin@gloria-ele.com</div>
          </div>
          <div class="optionBox-li">
            <div class="li-label">Wechat：</div>
            <div class="li-value">gloriaele</div>
            <img class="li-codeImg" src="~@/assets/images/contactUs/img_001.png"/>
          </div>
          <div class="optionBox-li">
            <div class="li-label">kakao talk:</div>
            <div class="li-value">yb.gloria</div>
          </div>
          <div class="optionBox-li">
            <div class="li-label">Skype/ Teams: </div>
            <div class="li-value">{{"Gloria Electronics\n(live:.cid.bdcb9a03130d7d13)"}}</div>
          </div>
          <div class="optionBox-li">
            <div class="li-label">Business Hours：</div>
            <div class="li-value">{{"Monday to Saturday, 9:00 AM – 6:00 PM (Beijing Time) \nLanguages Supported \nChinese, English, Korean "}}</div>
          </div>
        </div>
      </template>
      <template v-else-if="languageType==3">
        <div class="defaultScreenFooter-optionBox">
          <div class="optionBox-li">
            <div class="li-label">Telephone：</div>
            <div class="li-value">86-755-82543034</div>
          </div>
          <div class="optionBox-li">
            <div class="li-label">Mobile：</div>
            <div class="li-value">86-138 2879 8475</div>
          </div>
          <div class="optionBox-li">
            <div class="li-label">E-Mail：</div>
            <div class="li-value">yubin@gloria-ele.com</div>
          </div>
          <div class="optionBox-li">
            <div class="li-label">Wechat：</div>
            <div class="li-value">gloriaele</div>
            <img class="li-codeImg" src="~@/assets/images/contactUs/img_001.png"/>
          </div>
          <div class="optionBox-li">
            <div class="li-label">kakao talk:</div>
            <div class="li-value">yb.gloria</div>
          </div>
          <div class="optionBox-li">
            <div class="li-label">Skype/ Teams: </div>
            <div class="li-value">{{"Gloria Electronics\n(live:.cid.bdcb9a03130d7d13)"}}</div>
          </div>
          <div class="optionBox-li">
            <div class="li-label">Business Hours：</div>
            <div class="li-value">{{"Monday to Saturday, 9:00 AM – 6:00 PM (Beijing Time) \nLanguages Supported \nChinese, English, Korean "}}</div>
          </div>
        </div>
      </template>
      <div class="defaultScreenFooter-djBox">粤ICP备14010311号</div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'defaultFooter',
  data(){
    return {

    }
  },
  computed: {
    ...mapGetters(["languageType"]),
  },
}
</script>

<style rel="stylesheet/scss" scoped lang="scss">
#defaultFooter{

  .defaultFooter{
    box-sizing: border-box;
    width: 100%;
    background-color: #060708;
    padding: vw(60) vw(96) vw(40);
    display: block;

    .defaultFooter-logoBox{
      margin: 0 0 vw(80) 0;

      .logoBox-li1{
        float: left;
        width: vw(160);
        height: vw(35);
        margin: 0 vw(40) 0 0;
      }

      .logoBox-li2{
        float: left;
        width: vw(208);
        height: vw(35);
      }
    }

    .defaultFooter-content{

      .content-lp{
        float: left;
        width: calc( 100% - 179px );
        padding: 0 vw(120) 0 0;
        box-sizing: border-box;

        &-li{
          float: left;
          width: 25%;
          margin: 0 0 vw(20) 0;

          .li-label{
            font-size: vw(18);
            color: #A5A5A5;
            margin: 0 0 vw(10) 0;
          }

          .li-value{
            font-size: vw(18);
            color: #FFFFFF;
            height: vw(60);
            white-space: pre-wrap
          }
        }
      }

      .content-rp{
        float: right;
        width: vw(170);
        height: vw(170);

        &-codeImg{
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }

    .defaultFooter-djBox{
      text-align: center;
      font-size: 14px;
      color: #ffffff;
    }
  }

  .defaultScreenFooter{
    display: none;
    box-sizing: border-box;
    width: 100%;
    background-color: #060708;
    padding: 32px 25px 39px;

    &-logoBox{
      padding: 0 0 25px 0;
      border-bottom: 1px solid #A5A5A5;

      .logoBox-li1{
        float: left;
        width: 120px;
        height: 26px;
        margin: 0 38px 0 0;
      }

      .logoBox-li2{
        float: left;
        width: 167px;
        height: 26px;
      }
    }

    &-optionBox{
      padding: 25px 0 0 0;

      .optionBox-li{
        margin: 0 0 21px 0;

        .li-label{
          font-size: 12px;
          color: #A5A5A5;
          height: 12px;
          line-height: 12px;
          margin: 0 0 5px 0;
        }

        .li-value{
          min-height: 13px;
          line-height: 20px;
          font-size: 13px;
          color: #FFFFFF;
          white-space: pre-wrap
        }

        .li-codeImg{
          display: block;
          width: 75px;
          height: 75px;
          margin: 10px 0 0 0;
        }
      }
    }

    &-djBox{
      text-align: center;
      font-size: 14px;
      color: #ffffff;
    }
  }
}

@media screen and (max-width: 1400px) {
  .defaultFooter{
    display: none !important;
  }

  .defaultScreenFooter{
    display: block !important;
  }
}
</style>
